export const SHOW_TERMS_AND_CONDITIONS = "show-terms-and-conditions";
export const SHOW_TERMS_AND_CONDITIONS_WITHOUT_PROMPT = "show-terms-and-conditions-without-prompt";
export const HIDE_TERMS_AND_CONDITIONS = "hide-terms-and-conditions";
export const ACCEPT_TERMS_AND_CONDITIONS = "accept-terms-and-conditions";
export const REJECT_TERMS_AND_CONDITIONS = "reject-terms-and-conditions";